module.exports = __webpack_public_path__ + "img/加入我们_p2.6b232535.png";